export function sendToSheetAction(range, data, tableInfo) {
  return async function (dispatch, getState) {

    const body = JSON.stringify({
      range: range,
      values: data,
      tableInfo: tableInfo
    });

    try {
      const response = await fetch("/sheet", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: body,
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      // const responseData = await response.json();

    } catch (error) {
      console.error("Error:", error);
    }
  };
}



// WEBPACK FOOTER //
// ./src/actions/sheets.js